module.exports = __webpack_public_path__ + "static/assets/07c5c96ce66faba8684118c9e332a11f.svg";